export const stateProperties = [
  'top',
  'left',
  'scaleX',
  'scaleY',
  'flipX',
  'flipY',
  'originX',
  'originY',
  'angle',
  'opacity',
  'globalCompositeOperation',
  'shadow',
  'visible',
  'skewX',
  'skewY',
];

export const cacheProperties = [
  'fill',
  'stroke',
  'strokeWidth',
  'strokeDashArray',
  'width',
  'height',
  'paintFirst',
  'strokeUniform',
  'strokeLineCap',
  'strokeDashOffset',
  'strokeLineJoin',
  'strokeMiterLimit',
  'backgroundColor',
  'clipPath',
];

export const fabricObjectDefaultValues = {
  originX: 'center',
  originY: 'center',
  top: 0,
  left: 0,
  width: 0,
  height: 0,
  scaleX: 1,
  scaleY: 1,
  flipX: false,
  flipY: false,
  opacity: 1,
  angle: 0,
  skewX: 0,
  skewY: 0,
  cornerSize: 12,
  touchCornerSize: 24,
  transparentCorners: false,
  hoverCursor: null,
  moveCursor: null,
  padding: 0,
  borderColor: '#27A2F8',
  borderDashArray: null,
  cornerColor: 'rgb(255,255,255)',
  cornerBackgroundColor: 'rgb(255,255,255)',
  cornerStrokeColor: '#A9a9a9',
  cornerStyle: 'circle',
  cornerDashArray: null,
  centeredScaling: false,
  centeredRotation: true,
  fill: 'rgb(0,0,0)',
  fillRule: 'nonzero',
  globalCompositeOperation: 'source-over',
  backgroundColor: '',
  selectionBackgroundColor: '',
  selectionLineWidth: 2,
  stroke: null,
  strokeWidth: 2,
  strokeDashArray: null,
  strokeDashOffset: 0,
  strokeLineCap: 'butt',
  strokeLineJoin: 'miter',
  strokeMiterLimit: 4,
  shadow: null,
  borderOpacityWhenMoving: 0.4,
  borderScaleFactor: 1.5,
  minScaleLimit: 0,
  selectable: true,
  evented: true,
  visible: true,
  hasControls: true,
  hasBorders: true,
  perPixelTargetFind: false,
  includeDefaultValues: true,
  lockMovementX: false,
  lockMovementY: false,
  lockRotation: false,
  lockScalingX: false,
  lockScalingY: false,
  lockSkewingX: false,
  lockSkewingY: false,
  lockScalingFlip: false,
  excludeFromExport: false,
  objectCaching: false,
  noScaleCache: true,
  strokeUniform: false,
  dirty: true,
  paintFirst: 'fill',
  activeOn: 'down',
  colorProperties: ['fill', 'stroke', 'backgroundColor'],
  clipPath: undefined,
  absolutePositioned: false,
  FX_DURATION: 500,
  inverted: false,
  obj_type: '',
  zIndex: 0,
  statefullCache: false,
  isRemoteEditing: false,
  RemoteUserWhoEditing: '',
  NUM_FRACTION_DIGITS: 2,
  hasRotatingPoint: false,
  locked: false,
  isLoading: false,
  url: '',
  oneLine: false,
} as const;
